export const cleanPayload = (data)=>{
    const cleanPayload = Object.fromEntries(Object.entries(data).filter(([key,value])=>{
            return value !=="" && value !== null &&  value !== undefined && (!Array.isArray(value) || value.length > 0)
    }))
    return cleanPayload
}